export const desktopMenu = () => {
  $('.site-navigation .menu > li > a').click(function () {
    $(this).toggleClass('is-active');
  });

  function minimize() {
    if ($('.site-header').offset().top > 150) {
      $('.site-header').addClass('minimize');
    } else {
      $('.site-header').removeClass('minimize');
    }
    $('body').trigger('minimized');
  }

  // $(window).on('minimized', function () {
  //   console.log('worked');
  // });

  $(window).on('scroll', minimize);
};
